// components/ImagePickerModal.jsx
import React, { useMemo, useState, useEffect } from "react";
import Modal from "components/Modal";
import ActionButton from "components/ActionButton";
import ImagePicker from "./ImagePicker";

export default function ImagePickerModal({ isOpen, images = [], initialUrl, onClose, onConfirm, deviceSize, screenWidth, display, loadingDeepLinkDetails }) {
    const initialIndex = useMemo(() => {
        const i = images.findIndex(u => u === initialUrl);
        return i >= 0 ? i : 0;
    }, [images, initialUrl]);

    const [currentIdx, setCurrentIdx] = useState(initialIndex);
    useEffect(() => setCurrentIdx(initialIndex), [initialIndex]);

    const chosen = images[currentIdx] || null;

    return (
        <Modal
            isOpen={isOpen}
            toggleModal={onClose}
            hideOpenAsPage
            showHeader={false}
            showThreeDotMenu={false}
            modalDialogCustomClass="modal-dialog-md"
            modalContentStyle={{ backgroundColor: "black", marginTop: "100px", width: "500px", margin: "0 auto" }}
            closeIconFill="#444"
        >
            <div className="text-center">
                <ImagePicker
                    images={images}
                    initialIndex={currentIdx}
                    onChange={setCurrentIdx}
                    deviceSize={deviceSize}
                    screenWidth={screenWidth}
                    loadingDeepLinkDetails={loadingDeepLinkDetails}
                />

                <div className="d-flex justify-content-center" style={{ gap: 12, marginTop: 16 }}>
                    <ActionButton className="btn btn-secondary" onClick={onClose}>Cancel</ActionButton>
                    <ActionButton
                        className="btn btn-primary"
                        onClick={() => chosen && onConfirm(chosen)}
                        isDisabled={!chosen}
                    >
                        Use this image
                    </ActionButton>
                </div>
            </div>
        </Modal>            
    );
}
